// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Popover-container-heeqx {\n  position: relative;\n  display: inline-block;\n}\n.Popover-containerFullWidth-3FYuc {\n  display: block;\n}\n.Popover-popoverContainer-1_pIA {\n  z-index: 599;\n  background-color: #ffffff;\n  border-radius: 5px;\n  border: 1px solid #e0dfde;\n  padding: 10px;\n  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.05), 1px 1px 4px rgba(0, 0, 0, 0.04);\n}\n.Popover-closeButtonContainer-SBhtj {\n  position: absolute;\n  top: 3px;\n  right: 5px;\n  font-size: 13px;\n  --fi-size: 14px;\n}\n.Popover-closeIcon-2CwjL {\n  color: #a3a2a1;\n}\n.Popover-closeIcon-2CwjL:hover {\n  color: #1a1a1a;\n}\n.Popover-title-3EmFe {\n  font-size: 15px;\n  font-weight: 500;\n  margin: 0 20px 4px 0;\n  --fi-size: 18px;\n  --fi-stroke: var(--fi-stroke-m);\n}\n", ""]);
// Exports
exports.locals = {
	"container": "Popover-container-heeqx",
	"containerFullWidth": "Popover-containerFullWidth-3FYuc",
	"popoverContainer": "Popover-popoverContainer-1_pIA",
	"closeButtonContainer": "Popover-closeButtonContainer-SBhtj",
	"closeIcon": "Popover-closeIcon-2CwjL",
	"title": "Popover-title-3EmFe"
};
module.exports = exports;
